export const state = {
  cachedMenu: [
    {
      title: '方案價格',
      alias: 'plan',
    },
    {
      title: '預約系統方案',
      alias: 'basicplan',
    },
    {
      title: '系統行銷整合方案',
      alias: 'intermediateplan',
    },
    {
      title: '專人聯繫',
      alias: 'contact',
    }
  ]
};

export const getters = {};

export const mutations = {
    CACHE_MENU(state, menu) {
        state.cachedMenu = menu
    },
};

export const actions = {
    updateMenu({
        commit
    }, menu = {}) {
        commit('CACHE_MENU', menu)
    },
};
